import createMessagesMiddleware from "./messages";
import createMetricsMiddleware from "./metrics";
import createAsyncMiddleware from "./async";
/**
 * Redux middleware
 * @typedef {function} ReduxMiddleware
 */

/**
 * JS Auth Tools uses several middlewares (`asyncMiddleware`, `metricsMiddleware`, and
 * `messagesMiddleware`). Rather than configure each separately, it is strongly recommended that
 * you use `createAuthToolsMiddlewares` to configure and return the array of needed middlewares.
 * metrics and messages middlewares will only be included if you pass their respective options
 * @param  {object} options.asyncOptions    **required*** same options as `createAsyncMiddleware`
 * @param  {object} [options.metricsOptions]  **optional but strongly recommended** same options
 * as `createMetricsMiddleware`
 * @param  {object} [options.messagesOptions] optional.
 * @param  {function} [options.messagesOptions.successAction] see `createMessagesMiddleware`
 * @param  {function} [options.messagesOptions.errorAction] see `createMessagesMiddleware`
 * @return {array} of middlewares. async middleware at minimum but metrics or messages if
 * requested.
 */

export var createAuthToolsMiddlewares = function createAuthToolsMiddlewares(_ref) {
  var asyncOptions = _ref.asyncOptions,
      metricsOptions = _ref.metricsOptions,
      messagesOptions = _ref.messagesOptions;
  var middlewares = [createAsyncMiddleware(asyncOptions)];
  if (metricsOptions) middlewares.push(createMetricsMiddleware(metricsOptions));

  if (messagesOptions) {
    var successAction = messagesOptions.successAction,
        errorAction = messagesOptions.errorAction;
    middlewares.push(createMessagesMiddleware(successAction, errorAction));
  }

  return middlewares;
};
export { default as createMessagesMiddleware, getErrorMessages, getSuccessMessages } from "./messages";
export { default as createMetricsMiddleware } from "./metrics";
export { default as createAsyncMiddleware } from "./async";
export { default as createProviderSearchMiddleware } from "./provider-search";
export { default as providerDetailsMiddleware } from "./provider-details";
export { default as createProviderAccountStateMiddleware } from "./provider-account-status";
export { default as createProviderAccountLinkingMiddleware } from "./provider-account-linking";
export { default as providerAccountsMiddleware } from "./provider-accounts";
export { default as createProviderAccountsRefreshMiddleware } from "./provider-accounts-refresh";
export { default as transactionsPaginationMiddleware } from "./transactions-pagination";
export { default as transactionsBulkMiddleware } from "./transactions-bulk";
export { default as transactionMonthlyRollupsMiddleware } from "./transaction-monthly-rollups";
export { default as transactionsRecategorizationMiddleware } from "./transactions-recategorization";
export { default as transactionsTopSpendingMiddleware } from "./transactions-top-spending";
export { default as transactionRollupsMiddleware } from "./transaction-rollups";
export { default as googleTagManagerMiddleware } from "./google-tag-manager";
export { default as transactionsResyncMiddleware } from "./transactions-resync";
export { default as createFlowMiddleware } from "./flows/flow-middleware";
export { default as financialDataMiddleware } from "./financial-data";